var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8343 26.3627L18.0403 37.5306C19.1763 37.5306 19.6683 37.0426 20.2583 36.4566L25.5842 31.3667L36.6202 39.4486C38.6442 40.5766 40.0701 39.9826 40.6161 37.5866L47.8601 3.64279L47.8621 3.64079C48.5041 0.648808 46.7801 -0.521186 44.8081 0.21281L2.22834 16.5147C-0.677641 17.6427 -0.633641 19.2627 1.73435 19.9967L12.6203 23.3827L37.9062 7.56077C39.0962 6.77278 40.1781 7.20877 39.2881 7.99677L18.8343 26.3627Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.b75ac6634c787e82ebaee96737f6f804.svg";